'use client';

import { FC, PropsWithChildren } from 'react';

import { UserGroups } from '@ravago/shared/authentication';
import { AccessLevel } from '@ravago/shared/page-data/enums/access-level';
import { ContentfulCollectionName } from '@ravago/shared/page-data/models/contentful';
import { NormalizedCaseStudy, NormalizedEntity } from '@ravago/shared/page-data/models/contentful-mapped';
import { AccessLevelUtils } from '@ravago/shared/page-data/utils/access-level';

import AuthGuardService from '../../../services/auth-guard/auth-guard.service';

// TODO: move this to server https://www.freecodecamp.org/news/secure-routes-in-next-js/
interface Props extends PropsWithChildren {
   isConsumer: boolean;
   accessLevels?: AccessLevel[];
   locale?: string;
   contentEntity?: NormalizedEntity | null;
   contentType?: ContentfulCollectionName;
   redirectUserToLogin: boolean;
}

const AuthGuard: FC<Props> = ({ accessLevels, contentEntity, locale, isConsumer, contentType, redirectUserToLogin, children }) => {
   if (!isConsumer) return children;

   let userGroups: UserGroups[] = AccessLevelUtils.getUserGroupsByAccessLevel(accessLevels);

   if (contentType === 'caseStudy') {
      if ((contentEntity as NormalizedCaseStudy).visibility !== 'External') {
         userGroups = [UserGroups.ravagoGlobalGroupAdmin, UserGroups.ravagoSalesRepresentative, UserGroups.ravagoGlobalViewer];
      }
   }

   return AuthGuardService.isAuth(children, redirectUserToLogin, locale, userGroups);
};

export default AuthGuard;
